import React from 'react';

/**
 * TabBadge — the small pill an InnerTabsd / InnerTabsm `placeholder` renders:
 * a count ("12"), or a bell with an unread count. Coloured exactly like the
 * number on the Job Messages bell (.ca-msgbtn-dot): orange, dark text.
 *
 *   <TabBadge>{n}</TabBadge>            count pill
 *   <TabBadge bell unread={n} />        bell, dot with the unread count when > 0
 *   <TabBadge>{n}</TabBadge> renders nothing when n is null / undefined (no data yet)
 */
const DOT_BG = '#F97316';        // same as .ca-msgbtn-dot
const DOT_FG = '#0f172a';

const pill = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
  minWidth: 20, height: 20, padding: '0 6px', boxSizing: 'border-box',
  borderRadius: 999, fontSize: '0.72rem', fontWeight: 800, lineHeight: 1,
  color: DOT_FG, background: DOT_BG,
};
const bellWrap = { position: 'relative', display: 'inline-flex', alignItems: 'center', width: 18, height: 18 };
const dot = {
  position: 'absolute', top: -6, right: -8, minWidth: 17, height: 17, padding: '0 4px', boxSizing: 'border-box',
  borderRadius: 999, background: DOT_BG, color: DOT_FG, fontSize: '0.66rem', fontWeight: 800, lineHeight: '17px',
  textAlign: 'center',
};

const TabBadge = ({ bell = false, unread = 0, title, children }) => {
  if (bell) {
    return (
      <span style={bellWrap} title={title || (unread ? `${unread} unread` : 'Messages')} data-badge="bell">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {unread > 0 && <span style={dot} data-badge="dot">{unread}</span>}
      </span>
    );
  }
  if (children == null || children === false) return null;
  return <span style={pill} title={title} data-badge="count">{children}</span>;
};

export default TabBadge;
